import React, { Component } from 'react'
import { Input, Modal } from 'hljd'
import { inject, observer } from 'mobx-react'
import GroupItem from '@components/LocalMerchant/SiDa/Common/GroupItem'

@inject('store')
@observer
export default class extends Component {
  render() {
    const {
      visible,
      setStoreData,
      list,
      onApply,
      getList,
      inputSearch
    } = this.props.store.inviteModalStore

    return (
      <Modal
        title="邀请成员"
        visible={visible}
        onCancel={() => {
          setStoreData({ visible: false, inputSearch: '', list: [] })
        }}
        footer={null}
      >
        <Input.Search
          placeholder="请输入成员名称"
          enterButton="搜索"
          size="large"
          onSearch={value => getList({ name: value })}
          name="inputSearch"
          value={inputSearch}
          onChange={e => {
            const { name, value } = e.target
            setStoreData({ [name]: value })
          }}
          style={{ marginBottom: 30 }}
        />
        <div style={{ overflowY: 'auto', maxHeight: 500 }}>
          {list.map(item => {
            return (
              <GroupItem
                key={item.id}
                item={item}
                onApply={onApply}
                selectedText="已邀请"
                unSelectedText="邀请"
                selectedKey="invitationStatus"
                highlightText={inputSearch}
              />
            )
          })}
        </div>
      </Modal>
    )
  }
}
